// Страница входа и регистрации: показать/скрыть пароль.
// Разметку формы рисует crispy, поэтому кнопку вешаем на готовое поле и не
// оборачиваем его: обёртка разорвала бы связь input.is-invalid ~ .invalid-feedback
// и сообщения об ошибках перестали бы показываться.

function placeToggle($input, $toggle) {
    // у скрытой вкладки размеров нет, поэтому пересчитываем при её открытии
    $toggle.css('top', $input.position().top + 'px');
}

$(document).ready(() => {
    const toggles = [];

    $('.auth-form input[type="password"]').each(function () {
        const $input = $(this);
        const $holder = $input.parent().addClass('auth-password');
        const $toggle = $(
            '<button type="button" class="auth-password-toggle" tabindex="-1">' +
            '<i class="fas fa-eye-slash"></i></button>'
        ).appendTo($holder);

        $toggle.on('click', () => {
            const shown = $input.attr('type') === 'text';
            $input.attr('type', shown ? 'password' : 'text');
            $toggle.find('i').toggleClass('fa-eye-slash', shown).toggleClass('fa-eye', !shown);
        });

        toggles.push([$input, $toggle]);
        placeToggle($input, $toggle);
    });

    $('.auth-tabs a[data-toggle="tab"]').on('shown.bs.tab', () => {
        toggles.forEach(([$input, $toggle]) => placeToggle($input, $toggle));
    });
});
